module.exports = __webpack_public_path__ + "img/red_020.c1cd874a.png";